import simpleFlutterStr from "!!raw-loader!..\\..\\..\\..\\content\\blog\\flutter-hero-with-image-fit\\simple.dart.plain.txt";
import heroFlutterStr from "!!raw-loader!..\\..\\..\\..\\content\\blog\\flutter-hero-with-image-fit\\hero.dart.plain.txt";
import React from 'react';
export default {
  simpleFlutterStr,
  heroFlutterStr,
  React
};